module.exports = __webpack_public_path__ + "img/palmar-room-13.681f4cc6.jpg";